import { useEffect, useState, useMemo, useRef } from 'react'
import Nav from '../Nav'
import styles from './index.less'
import AssetPopup from '../AssetPopup'
import UserInfoPopup from '../UserInfoPopup'
import ToolsCrumbNav from '../ToolsNavPopup/CrumbNav'
import LoginDialog from '@/components/LoginDialog'
import CreatePlatform from '../CreatePlatform'
import { history, useRouteProps } from 'umi'
import classNames from 'classnames'
import { getCookie } from '@/utils/cookie'
import PopUser from '../PopUser'
import { useStore, setIsLogin } from '@/states/store'
import { getUserInfo } from '@/utils/getUserInfo'
import logo from '@/assets/icon/logo/logo.svg'
import { ReactComponent as Logo } from '@/assets/icon/logo/logo.svg'
import { ReactComponent as PersonLogo } from '@/assets/icon/logo/crumb-person.svg'
import { ReactComponent as CreateLogo } from '@/assets/icon/logo/crumb-create.svg'
import { Popover } from 'antd'
import { isMac } from '@/utils/util'
import { openLoginDialog } from '@/components/LoginDialog/openLoginDialog'
import BindTel from '@/components/BindTel'
import { MemberType } from '@/constants'
import PopCode from '../PopCode'
import goToRoute from '@/utils/goToRoute'
import RprmUtils from '@/utils/dot'

export default () => {
  const router = useRouteProps()

  const [showLogin, setShowLogin] = useState(false)

  const baseStore = useStore()

  const [showMask, setShowMask] = useState(false)

  const [showBindTel, setShowBindTel] = useState(false)

  useEffect(() => {
    setIsLogin(!!getCookie('token'))
    // if (!router.meta?.hideOperation) {
    getUserInfo()
    // }

    // preloadImg([
    //   'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/yaoqingyoulirukou-hover@3x.png',
    //   'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/99kaitonghuiyuan-hover@3x.png'
    // ])
  }, [])

  const onLogin = () => {}

  const preloadImg = (imgUrls: any) => {
    imgUrls.forEach((imgUrl: any) => {
      // 生成图片对象
      const img = new Image()
      img.src = imgUrl
    })
  }

  const openLogin = () => {
    openLoginDialog({})
  }

  // 小工具页面
  const isToolsPage = useMemo(() => {
    return router.path.startsWith('/tools/')
  }, [router?.path])

  return (
    <>
      <header
        style={{ backgroundColor: showMask ? '#fff' : 'transparent' }}
        id="header"
        className={classNames(styles.header, router.meta?.hideBorder && styles.noBorder)}
      >
        <div className={styles.main}>
          <div className={styles.logo}>
            <Popover
              // open={popoverShow}
              // onOpenChange={setPopoverShow}
              content={`按${isMac() ? '「⌘+D」' : '「Ctrl+D」'}收藏本站 或 拖动LOGO到书签栏`}
              placement="bottomLeft"
              overlayClassName={styles.headLogoPop}
            >
              <a href="/">
                <img src={logo} alt="WIME" />
              </a>
            </Popover>
            {router.meta?.crumb && (
              <>
                <div className={styles.dividerLine} />
                {router.meta?.crumb === 'preson' ? (
                  <PersonLogo className={styles.crumbLogo} />
                ) : (
                  <CreateLogo className={styles.crumbLogo} />
                )}
              </>
            )}
            {isToolsPage && <ToolsCrumbNav />}
          </div>

          {!router.meta?.hideNav && <Nav setShowMask={setShowMask} />}
        </div>

        {router.meta?.showWorkbench && <CreatePlatform />}

        {!router.meta?.hideOperation && (
          <div className={styles.operate}>
            {/* tools 页面 header右侧自定义操作 */}
            {isToolsPage && <div id="tools-page-header-right" />}
            {router.meta?.showInvite && (
              <div
                className={styles.invite}
                onClick={() => {
                  RprmUtils.rec(`invite_tap`, 'view', { en: 'tap', et: 'custom',element_content:'活动入口'})
                  goToRoute('/inviteActivity')
                }}
              >
                <img
                  className={styles.inviteImg}
                  src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/yaoqingyoulirukou@3x.png"
                  alt=""
                />
                <img
                  className={styles.inviteHoverImg}
                  src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/yaoqingyoulirukou-hover2@3x.png"
                  alt=""
                />
              </div>
            )}
            {/* {router.meta?.showCode&&<PopCode/>} */}
            {!baseStore.isLogin && (
              <PopUser
                openLoginModal={() => {
                  openLogin()
                }}
              />
            )}
            {!baseStore.isLogin && (
              <button
                onClick={() => {
                  openLogin()
                }}
                className={styles.login}
              >
                登录/注册
              </button>
            )}

            {baseStore.isLogin && <AssetPopup userInfo={baseStore.userInfo} isShow={baseStore.isShowRewardPop} />}

            {baseStore.isLogin && <UserInfoPopup userInfo={baseStore.userInfo} />}
            {baseStore.isLogin && baseStore.userInfo?.userId && !baseStore.showRewardPop && !baseStore.userInfo?.mobileNo && (
              <div
                className={styles.popTips}
                onClick={e => {
                  e.stopPropagation()
                  setShowBindTel(true)
                }}
              >
                <div className={`icon-SignInfoFill ${styles.tipsIcon}`} />
                <div className={styles.tipsTxt}>为保障您的资产安全，请绑定手机号</div>
                <div className={styles.bindBtn}>去绑定</div>
                <img
                  className={styles.star}
                  src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/tooltipzhuangshi@2x.png"
                />
              </div>
            )}
          </div>
        )}
      </header>
      {/* <LoginDialog open={showLogin} onLogin={onLogin} onClose={() => setShowLogin(false)} /> */}
      {showMask && <div className={styles.mask} />}
      {showBindTel && (
        <BindTel
          show={showBindTel}
          closeBindTel={() => {
            setShowBindTel(false)
          }}
        />
      )}
    </>
  )
}
